import { LAUNCH_VIEW_NAME } from "../core/constants";
import { getDomainCfg } from "../core/state";
import { getViewData } from "../core/views";
import { loadSettingsFromLS } from "./localstorage/settings";
import { removeLineBreaks } from "./loccount";

export const mergeAssets = (state : any) : string => {
  const userAssetsArray : string[] = [];
  /*
  TODO: userAssets
  if (state.applicationData.userAssets) {
    userAssetsArray = state.applicationData.userAssets;
  }*/

  let projectAssetsArray = [];
  if (state.data.projectContent.projectAssets && state.data.projectContent.projectAssets.length > 0) {
    const projectAssets = JSON.parse(state.data.projectContent.projectAssets);
    projectAssetsArray = projectAssets.assets;
  }

  if (userAssetsArray.length > 0 && projectAssetsArray.length > 0) {
    const mergedAssets = { assets : projectAssetsArray.concat(userAssetsArray) };
    return JSON.stringify(mergedAssets).replace(/"/g,'\\"');
  } else if (projectAssetsArray.length > 0) {
    return removeLineBreaks(state.data.projectContent.projectAssets).replace(/"/g,'\\"');
  } else if (userAssetsArray.length > 0) {
    const userAssets = { assets : userAssetsArray };
    return JSON.stringify(userAssets).replace(/"/g,'\\"');
  }

  const emptyAssets = { assets : [] };
  return JSON.stringify(emptyAssets).replace(/"/g,'\\"');
}


export const collectSettings = (context : string, state : any) => {
  loadSettingsFromLS();
  const launchViewData = getViewData(LAUNCH_VIEW_NAME);

  let settings = launchViewData?.data?.settings;
  if (settings === undefined) {
    settings = {};
  }

  const codeSettings = {
    ...settings,
    projectSettings : state.project.settings,
    context,
    lang : getDomainCfg().lang
  }

  const settingsString = JSON.stringify(codeSettings).replace(/"/g,'\\"');
  return settingsString;
}
